/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Type of the field
 */
export enum DocumentFieldType {
    TEXT = 'text',
    NUMBER = 'number',
    DATE = 'date',
    MULTI_SELECT = 'multiSelect',
    SELECT = 'select',
    MULTI_SELECT_WITH_NESTED_COLLAPSABLE_CHILDREN = 'multiSelectWithNestedCollapsableChildren',
    BOOLEAN = 'boolean',
    LIST = 'list',
}
